import React, { useContext } from 'react';
import { DialogStateContext } from '../../../context/DialogStateContextProvider';
import { IconZoomType } from '../../../context/TransitsContextProvider';
import TrainZoomMap, { DirectionType } from '../../atoms/svg/TrainZoomMap';

const directions: { [key in number]: DirectionType } = {
  1: 'top',
  2: 'bottom',
  3: 'left',
  4: 'right'
};
Object.freeze(directions);

type Props = {
  icons: Array<IconZoomType>;
};

const TrainsZoomMap: React.FC<Props> = (props) => {
  const { icons } = props;
  const { openDialog } = useContext(DialogStateContext);

  return (
    <>
      {icons.map((icon) => {
        return (
          <TrainZoomMap
            key={`train_zoom_${icon.train_no}`}
            x={icon.x}
            y={icon.y}
            direction={directions[icon.arrow]}
            no={icon.train_no}
            color={icon.color}
            logo={icon.logo}
            onClick={() => {
              openDialog(
                'placeInfo',
                icon.place_id.toString(),
                icon.index_in_place
              );
            }}
          ></TrainZoomMap>
        );
      })}
    </>
  );
};

export default React.memo(TrainsZoomMap);
